import styled from "styled-components";
import { Modal } from 'react-bootstrap';

export const ContainerAdressChoice = styled.div`
  width : 100%;
  padding : 20px;
  display : flex;
  flex-direction: column; 
  text-align : center;
`

export const CustomModal = styled(Modal)`

`

export const BoxPedido = styled.div`
  width: 100%;
  height: 480px;

  position: relative; 
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 45px;    
  display: flex;
  flex-direction: column;
`

export const BoxAccount = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute; 
  top: 0;
  left: 0;
  background: rgba(255,255,255, .7);
  border-radius: 4px;
`